import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { useState } from "react";
import { parseISO } from "date-fns";

export default function FilterDialog({
  open,
  handleClose,
  onChangeFilter,
  loading,
  data,
}) {
  const [startDate, setStartDate] = useState(
    data.start ? parseISO(data.start) : null
  );
  const [finishDate, setFinishDate] = useState(
    data.finish ? parseISO(data.finish) : null
  );
  const [deleted, setDeleted] = useState(data?.deleted || null);

  const handleClickFilter = () => {
    let { format } = require("date-fns");

    const values = {
      deleted: deleted || false,
      start: (startDate && format(startDate, "yyyy-MM-dd")) || "",
      finish: (finishDate && format(finishDate, "yyyy-MM-dd")) || "",
    };

    onChangeFilter(values);
  };

  const handleClearFilter = () => {
    setStartDate(null);
    setFinishDate(null);
    setDeleted(null);

    const obj = {
      deleted: null,
      start: null,
      finish: null,
    };

    onChangeFilter(obj);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      scroll="paper"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Filtrar</DialogTitle>
      <DialogContent style={{ marginTop: 20, marginBottom: 20 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
              <DatePicker
                disableFuture
                variant="inline"
                inputVariant="outlined"
                label="Início"
                format="dd/MM/yyyy"
                value={startDate}
                fullWidth
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => setStartDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
              <DatePicker
                disableFuture
                variant="inline"
                inputVariant="outlined"
                label="Fim"
                format="dd/MM/yyyy"
                value={finishDate}
                fullWidth
                InputAdornmentProps={{ position: "start" }}
                onChange={(date) => setFinishDate(date)}
              />
            </MuiPickersUtilsProvider>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Débito excluído"
              value={deleted}
              onChange={(e) => setDeleted(e.target.value)}
              variant="outlined"
              fullWidth
            >
              <MenuItem value={true}>Sim</MenuItem>
              <MenuItem value={false}>Não</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
      <Button
          onClick={() => {
            handleClearFilter();
            handleClose();
          }}
          color="primary"
        >
          Limpar filtros
        </Button>

        <Button
          onClick={() => {
            handleClickFilter();
            handleClose();
          }}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          Filtrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
